import dayjs from "dayjs";
import React from "react";
import { convertDateToDateTime } from "../../../../helper/formatDate/formate-date";
import { formatDateTime } from "../../../../utils/format";

function Stats({ data }) {
  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className="flex divide-x divide-black justify-between p-5 rounded-[4px]"
    >
      <div className="w-1/4 text-center">
        <div className="text-[#000]">등록일시</div>
        <p className="font-bold mt-1 text-[14px]">
          {formatDateTime(data?.createdAt)}
        </p>
      </div>
      <div className="w-1/4 text-center">
        <div className="text-[#000]">발송번호</div>
        <p className="font-bold mt-1 text-[14px]">{data?.smsId ?? "-"}</p>
      </div>
      <div className="w-1/4 text-center">
        <div className="text-[#000]">발송 유형</div>
        <p className="font-bold mt-1 text-[14px]">
          {data?.isImmediate === true ? "즉시 발송" : "예약 발송"}
        </p>
      </div>
      <div className="w-1/4 text-center">
        <div className="text-[#000]">발송 예정 일시</div>
        <p className="font-bold mt-1 text-[14px]">
          {data?.scheduleTime !== null ? (
            <span
              className={`${data?.isSent === false ? " text-[#e80000]" : ""} ${
                data?.isCanceled === true ? "line-through decoration-black" : ""
              }`}
            >
              {formatDateTime(data?.scheduleTime)}
            </span>
          ) : (
            formatDateTime(data?.createdAt)
          )}
        </p>
      </div>
    </div>
  );
}

export default Stats;
